import {
  ITotalProgram,
  Scenario,
  CalculatorType,
} from 'spw-redux/modules/calculators/types';
import { IDepartment } from 'spw-redux/modules/projects/types';
import BuildingHeadcountScenario from './BuildingHeadcountScenario';
import BuildingUSFScenario from './BuildingUSFScenario';
import DepartmentScenario from './DepartmentScenario';
import FloorHeadcountScenario from './FloorHeadcountScenario';
import FloorUSFScenario from './FloorUSFScenario';
import MacroScenario from './MacroScenario';
import { IProgramScenario, PlainProgramScenario } from './Scenario';
import TotalProgramScenario from './TotalProgramScenario';

export default class ProgramScenarioFactory {
  static create(
    apiScenario: Scenario | ITotalProgram,
    linkedScenarios?: Scenario[] | PlainProgramScenario[]
  ): IProgramScenario | null {
    if (!apiScenario) return null;
    switch (apiScenario.calculatorType) {
      case 'building-headcount-seatcount-departments':
        return new DepartmentScenario(apiScenario);
      case 'building-headcount-seatcount':
        return new BuildingHeadcountScenario(apiScenario);
      case 'floor-headcount-seatcount':
        return new FloorHeadcountScenario(apiScenario);
      case 'macro-programming':
        return new MacroScenario(apiScenario);
      case 'building-usf':
        return new BuildingUSFScenario(apiScenario);
      case 'floor-usf':
        return new FloorUSFScenario(apiScenario);
      case 'total-program':
        return new TotalProgramScenario(
          apiScenario as ITotalProgram,
          linkedScenarios
        );
      default:
        throw new Error("The calculator type specified doesn't exist");
    }
  }

  static parseToAnotherCalculatorType(
    scenario: PlainProgramScenario,
    calculatorType: CalculatorType,
    options?: {
      department?: IDepartment;
      floorId?: number;
      departmentsYear?: number;
    }
  ): PlainProgramScenario {
    const { department, floorId, departmentsYear } = options;
    switch (calculatorType) {
      case 'macro-programming':
        return MacroScenario.parseFromAnotherCalculatorType(scenario);
      case 'building-headcount-seatcount':
        return BuildingHeadcountScenario.parseFromAnotherCalculatorType(
          scenario
        );
      case 'building-headcount-seatcount-departments':
        return DepartmentScenario.parseFromAnotherCalculatorType(
          scenario,
          department,
          departmentsYear
        );
      case 'floor-headcount-seatcount':
        return FloorHeadcountScenario.parseFromAnotherCalculatorType(
          scenario,
          floorId
        );
      case 'building-usf':
        return BuildingUSFScenario.parseFromAnotherCalculatorType(scenario);

      case 'floor-usf':
        return FloorUSFScenario.parseFromAnotherCalculatorType(
          scenario,
          floorId
        );
      default:
        throw new Error("The calculator type specified doesn't exist");
    }
  }
}
